import { Iterable } from 'immutable';
import jack from 'jack-logs';
import { logActions } from './jack';
import airbrake from './Airbrake';

export async function updateDeviceSpreadsheet() {
  if (!window.device || !window.cordova || !window.cordova.getAppVersion) {
    return null;
  }
  const details = {
    type: window.device.manufacturer.substring(0, 1).toUpperCase()
    + window.device.manufacturer.slice(1),
    model: window.device.model,
    os: window.device.platform,
    osVersion: window.device.version,
    app: await window.cordova.getAppVersion.getVersionNumber(),
  };

  return fetch('https://timeclock.tanda.co/device', {
    body: JSON.stringify(details),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  }).catch(e => jack.error(e));
}


export default async function logApplicationStart(state) {
  const device = Iterable.isIterable(state)
    ? state.get('device')
    : state.device;

  if (!device || !device.get('deviceId')) {
    jack.dev.log({ action: logActions.APPLICATION_BOOT, message: 'Application started by new user' });
  } else {
    jack.dev.log({
      action: logActions.APPLICATION_BOOT,
      device: device.toJS(),
      message: 'Application restarted',
    });
  }

  // send device details to the server
  try {
    await updateDeviceSpreadsheet();
  } catch (e) {
    airbrake.notify(e);
  }
}



// WEBPACK FOOTER //
// ./src/lib/logApplicationStart.js